import { MotionConfig } from "framer-motion";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { LandingFooter, LandingNav, CloseBand } from "@/components/landing/LandingShared";
import { LandingHero } from "@/components/landing/LandingHero";
import { LiveTranslatorBand } from "@/components/landing/LiveTranslatorBand";
import { PricingSection } from "@/components/landing/PricingSection";
import { SceneGallery } from "@/components/landing/SceneGallery";
import { WhyItSticks } from "@/components/landing/WhyItSticks";

const Landing = () => (
  <MotionConfig reducedMotion="user">
    <div className="min-h-screen overflow-x-hidden bg-neutral-50 text-neutral-900">
      <LandingNav />
      <main>
        <LandingHero />
        <HowItWorks />
        <LiveTranslatorBand />
        <PricingSection />
        <SceneGallery />
        <WhyItSticks />
        <CloseBand />
      </main>
      <LandingFooter />
    </div>
  </MotionConfig>
);

export default Landing;
